module.exports = __webpack_public_path__ + "static/media/IMG_6329.144df8a8.JPG";